module.exports = __webpack_public_path__ + "static/img/bind.1a57f79.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bind.png
// module id = OK72
// module chunks = 1